import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query";
import { AxiosError } from "axios";
import {
  apiOnboardingKeyName,
  apiOnboardingKeyValue,
  baseOnboardingApiURL,
  getOnfidoFetcher,
  getRecaptchaToken,
  transformAxiosToFetchBaseQueryErrorWithLocationRedirect,
} from "../../..";
import {
  TOnfidoInitPayload,
  TOnfidoInitResponse,
  TOnfidoSavePayload,
  TOnfidoSaveResponse,
} from "../types";

export const onfidoApi = createApi({
  reducerPath: "onfidoApi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseOnboardingApiURL,
    prepareHeaders: headers => {
      if (apiOnboardingKeyName && apiOnboardingKeyValue) {
        headers.set(apiOnboardingKeyName, apiOnboardingKeyValue);
      }
      return headers;
    },
  }),
  endpoints: build => ({
    init: build.mutation<TOnfidoInitResponse, TOnfidoInitPayload>({
      async queryFn(body: TOnfidoInitPayload) {
        try {
          const res = await getOnfidoFetcher().post("init", body, {
            withCredentials: true,
          });
          return { data: res?.data };
        } catch (e) {
          const error = transformAxiosToFetchBaseQueryErrorWithLocationRedirect(
            e as AxiosError,
            true,
          );
          return { error };
        }
      },
    }),
    save: build.mutation<TOnfidoSaveResponse, TOnfidoSavePayload>({
      async queryFn(body: TOnfidoSavePayload) {
        try {
          const gRecaptchaResponse = await getRecaptchaToken();
          const res = await getOnfidoFetcher({ gRecaptchaResponse }).post(
            "save",
            body,
            {
              withCredentials: true,
            },
          );
          return { data: res?.data };
        } catch (e) {
          const error = transformAxiosToFetchBaseQueryErrorWithLocationRedirect(
            e as AxiosError,
            true,
          );
          return { error };
        }
      },
    }),
  }),
});

export const allOnfidoRejectedMatchers = [
  onfidoApi.endpoints.init.matchRejected,
  onfidoApi.endpoints.save.matchRejected,
];
export const allOnfidoPendingMatchers = [
  onfidoApi.endpoints.init.matchPending,
  onfidoApi.endpoints.save.matchPending,
];
export const allOnfidoFulfilledMatchers = [
  onfidoApi.endpoints.init.matchFulfilled,
  onfidoApi.endpoints.save.matchFulfilled,
];
